import { Checkbox, Input } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { SearchDrawerComponent } from '../../../../../components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'
import { setEmployeelFilter } from '../../../../../stores/actions'

const StyledRow = styled.div`
  margin-bottom: 10px;
`

const StyledLabel = styled.span`
  border: 1px solid #d9d9d9;
  padding: 3px 10px;
  margin-right: 10px;
  background-color: #fafafa;
  display: inline-flex;
`

export const SearchEmployeeDrawerComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { language } = useSelector((state: RootState) => state.language)
  const { employeeFilter } = useSelector((state: RootState) => state.employee)
  const [filter, setFilter] = React.useState(employeeFilter)

  const body = (
    <>
      <StyledRow>
        <Input
          placeholder={translate('employee.name', language)}
          addonBefore={translate('employee.name', language)}
          value={filter.name}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              name: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('common.phone', language)}
          addonBefore={translate('common.phone', language)}
          value={filter.phone}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              phone: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <StyledLabel>{translate('common.gender', language)}:</StyledLabel>
        <Checkbox.Group
          options={[true, false].map((item) => {
            return {
              label: translate(
                `common.gender.${item ? 'male' : 'female'}`,
                language
              ),
              value: item.toString(),
            }
          })}
          defaultValue={['true', 'false']}
          value={filter.genders}
          onChange={(e) =>
            setFilter({
              ...filter,
              genders: e ? e.map((item) => item.toString()) : ['true', 'false'],
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('employee.station', language)}
          addonBefore={translate('employee.station', language)}
          value={filter.stationName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              stationName: e.target.value,
            })
          }
        />
      </StyledRow>
    </>
  )

  return (
    <SearchDrawerComponent
      body={body}
      onSearch={() => dispatch(setEmployeelFilter(filter))}
    />
  )
}
